// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "ddf8eab001c30991","396": "164d28b64c52cfdc","460": "73cc9b369a57fb3e","917": "83cd1603960918fa","985": "699cb2efa8e22ab2",}[chunkId] + ".chunk.js"
}